import clsx from "classnames";
import TileCard2 from "components/Shared/TileCard2";
import { motion } from "framer-motion";
import useWhoWeRecruit from "hooks/useWhoWeRecruit";
import { useEffect, useRef, useState } from "react";
import { Container } from "reactstrap";
import Buttons from "ui/Buttons/component";
import styles from "./styles.module.scss";
import OverlayDots from "/public/site-assets/svg/overlay-dots.svg";

import FooterWave2Icon from "@/public/site-assets/svg/footer-wave-2.svg";

export const WhoWeRecruitBox = ({
  className,
  heading,
  content,
  content_2,
  buttons,
  with_hyperlink,
  items,
  showWave,
  waveDirection,
  waveColor,
  waveBackground,
  showTopWave,
  topWaveDirection,
  topWaveColor,
  topWaveBackground,
}) => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  const fallbackPosts = useWhoWeRecruit();
  const postsToRender = items && items.length > 0 ? items : fallbackPosts;

  useEffect(() => {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.1, // Adjust threshold as needed, make it smaller for more sensitive detection
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      });
    }, options);

    observer.observe(sectionRef.current);

    // Cleanup function
    return () => {
      observer.disconnect();
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      const mobileDevice = window.innerWidth <= 991; // Adjust threshold for mobile devices
      // setIsVisible(!mobileDevice); // Hide motion on mobile devices
    };

    handleResize(); // Call initially
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <>
      {showTopWave && (
        <div
          className={clsx(
            "footer",
            topWaveDirection === "down" && "rotate",
            topWaveColor,
            topWaveBackground,
          )}
          style={{ marginBottom: "-1px", zIndex: 1, position: "relative" }}
        >
          <FooterWave2Icon />
        </div>
      )}
      <section ref={sectionRef} className={clsx(className, styles.root)}>
        <Container>
          <div className="wrapper align-items-center">
            <div className="position-relative">
              {heading && <h2 className={`h3 mb-3 position-relative z-index-1`}>{heading}</h2>}
              {content && (
                <div
                  className={`content focused-text position-relative z-index-1`}
                  dangerouslySetInnerHTML={{ __html: content }}
                />
              )}
              <div className="overlay-dots">
                <OverlayDots />
              </div>
            </div>
            <div className="position-relative">
              <div className="mb-5 tiles d-flex flex-wrap justify-content-between">
                {postsToRender.map((post, index) => (
                  <motion.div
                    className={`column`}
                    initial={{ opacity: 0, y: 50 }}
                    animate={isVisible ? { opacity: 1, y: 0 } : {}}
                    transition={{ duration: 0.5, delay: index * 0.1 }}
                    key={index}
                  >
                    <TileCard2 post={post} with_hyperlink={with_hyperlink} />
                  </motion.div>
                ))}
              </div>
              {content_2 && (
                <div className={`content`} dangerouslySetInnerHTML={{ __html: content_2 }} />
              )}
              {buttons && (
                <Buttons buttons={buttons} className="d-flex align-items-center text-center" />
              )}
              <div className="overlay-dots">
                <OverlayDots />
              </div>
            </div>
          </div>
        </Container>
        {showWave && (
          <div
            className={clsx(
              "footer",
              waveDirection === "down" && "rotate",
              waveColor,
              waveBackground,
            )}
            style={{ marginTop: "-1px" }}
          >
            <FooterWave2Icon />
          </div>
        )}
      </section>
    </>
  );
};

export default WhoWeRecruitBox;
